import { IAdapter, IAdaptProductColorsImages } from "./types";

export default class ProductAdaptee implements IAdapter {

  transform(product: any) {
    const productColorsImages: IAdaptProductColorsImages = {
      colors: [],
      img: "",
    };

    product.productColorsImages.forEach((productColorImage: any) => {
      productColorsImages.colors.push(productColorImage.color);
      productColorsImages.img = productColorImage.img1;
    });

    product.prices = {
      displayCreditOldPriceInRate: product.displayCreditOldPriceInRate,
      displayCreditPrice: product.displayCreditPrice,
      displayCreditPriceInRate: product.displayCreditPriceInRate,
      displayCreditRate: product.displayCreditRate,
      displayPrice: product.displayPrice,
    };
    product.productColorsImages = productColorsImages;

    return product;
  }

}
